module.exports = __webpack_public_path__ + "static/media/user-chat.307c516e.svg";